import {Controller} from "stimulus"
import $ from 'jquery';
import bootbox from 'bootbox/bootbox';
import toastr from 'toastr/toastr'
import 'toastr/toastr.scss'
import 'bootstrap-table/dist/bootstrap-table.min.css'
import 'bootstrap-table/dist/bootstrap-table.min'
import 'bootstrap-table/dist/locale/bootstrap-table-es-ES.min'
import 'bootstrap-table/dist/extensions/custom-view/bootstrap-table-custom-view'
import 'bootstrap-table/dist/extensions/editable/bootstrap-table-editable'
import {obtenerIdCheckDatatable} from "./admin_controller";


export default class extends Controller {

    connect() {
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "3000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }

        let table = $('#table');
        let table_notification = $('#table_notification');
        let table_personalized = $('#table_personalized');
        let admin_table = $('#admin_table');
        let revision_table = $('#revision_table');
        let revision_history_table = $('#revision_history_table');
        let table_with_custom_view = $('#table_with_custom_view');
        table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 10,
            pageList: "[10, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            // idField: "id",
            // selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });
        table_notification.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            // idField: "id",
            // selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });
        table_personalized.bootstrapTable({
            language: 'es',
            pagination: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            toolbarAlign: "left",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });
        admin_table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: false,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 5,
            pageList: "[5, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });
        revision_table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 5,
            pageList: "[5, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });
        revision_history_table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 5,
            pageList: "[5, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }
        });
        table_with_custom_view.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageList: "[5, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
                $('button[name="customView"]').map((index, element) => {
                    $(element).trigger('click');
                })
            }, onPageChange: function (number, size) {
                $('button[name="customView"]').map((index, element) => {
                    $(element).trigger('click');
                })
            }
        });
        table_with_custom_view.on('refresh.bs.table', function(e, params) {
            $('button[name="customView"]').map((index, element) => {
                $(element).trigger('click');
            })
        });

        $('#table_client').bootstrapTable();
        $('#table_client_two').bootstrapTable();
        $('[data-toggle="table-client"]').bootstrapTable();

        $('#checkBtn').on('change', function () {
            $('.inputBtnDataTable').prop('checked', $(this).is(':checked'));
        })


    }


    edit(e) {
        let ids = obtenerIdCheckDatatable();
        if (ids.length < 1) {
            toastr.info('Debe seleccionar la menos un elemento para continuar con esta acción', 'Importante')
        } else {
            location.href = `${location.origin}${e.target.dataset.url}?targets=${ids}`
        }

    }

    delete(e) {
        bootbox.confirm({
            message: "¿Seguro que desea eliminar este elemento? <br> <p style='font-size: .7em;' class='text-danger'>Tenga en cuenta que este proceso es inreversible.</p>",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target + '/delete',
                        data: {
                            format: 'json'
                        },
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                                $('#table_client').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                // console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    deleteBlock(e) {
        let ids = obtenerIdCheckDatatable();
        if (ids.length < 1) {
            toastr.info('Debe seleccionar al menos un elemento para continuar con esta acción', 'Importante')
        } else {
            bootbox.confirm({
                message: `¿Seguro que desea eliminar estos ${ids.length} elementos? <br> <p style='font-size: .7em;' class='text-danger'>Tenga en cuenta que este proceso es inreversible.</p>`,
                buttons: {
                    confirm: {
                        label: '<i class="fa fa-check"></i> Aceptar',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: '<i class="fa fa-times"></i> Cancelar',
                        className: 'btn-secondary'
                    }
                },
                size: 'small',
                callback: function (result) {
                    if (result) {
                        $.ajax({
                            url: e.target.dataset.url,
                            data: {
                                format: 'json',
                                id: ids
                            },
                            type: 'GET',
                            success: function (data) {
                                if (data.success) {
                                    toastr.success(data.msg);
                                    $('#table').bootstrapTable('refresh');
                                    $('#table_client').bootstrapTable('refresh');
                                } else {
                                    toastr.error(data.msg);
                                    // console.log(data.msg);
                                }
                            }
                        })
                    }
                }
            })
        }


    }

    disabled(e) {
        bootbox.confirm({
            message: "¿Seguro que desea habilitar/deshabilitar este elemento?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target + '/disabled',
                        data: {
                            format: 'json'
                        },
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                                $('#table_client').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                // console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    block(e) {
        bootbox.confirm({
            message: "¿Seguro que desea bloquear el acceso y la renta a este usuario?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target + '/block',
                        data: {
                            format: 'json'
                        },
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                // console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    change_status(e) {

        bootbox.confirm({
            message: "¿Seguro que desea cambiar el estado de disponibilidad?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target,
                        data: {
                            format: 'json'
                        },
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                // console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    commercial(e) {
        // console.log(e);
        bootbox.confirm({
            message: "¿Seguro que desea poner este usuario como Comercial del sitio?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target,
                        data: {
                            format: 'json'
                        },
                        type: 'POST',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                // console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    filterTable(e) {
        $(`#${e.target.dataset.table}`).bootstrapTable('refresh');
    }

    clearFilter(e) {
        let parentElement = $(`#${e.target.dataset.target}`);
        let input = parentElement.find('input[type="text"]');
        let input_hidden = parentElement.find('input[type="hidden"]');
        let select = parentElement.find('select');

        input.map((index, elem) => {
            elem.value = '';
        })
        input_hidden.map((index, elem) => {
            elem.value = '';
        })
        select.map((index, elem) => {
            $(elem).val(null).trigger('change');
        })
    }

    checkUncheckAll(e) {
        $('.inputBtnDataTable').prop('checked', $(e.target).is(':checked'));
    }

    mark_as_pay(e) {

        if (e.target.dataset.voucher !== undefined && e.target.dataset.voucher === 'true') {
            let ids = obtenerIdCheckDatatable();
            let message = '¿Desea marcar como <b>"PAGADO"</b> todas las Reservas.?'
            if (ids.length > 0) {
                message = `¿Desea marcar como <b>"PAGADO"</b> las (${ids.length}) Reservas seleccionadas.?`;

            } else {
                toastr.info('Debe seleccionar al menos 1 reserva para marcar como "PAGADO"', 'Información')
            }

            bootbox.confirm(message, (result) => {
                if (result) {
                    $.ajax({
                        url: `${location.origin}/admin/histories/agencies/billing/mark`,
                        data: {
                            agency_billing: e.target.dataset.last,
                            vouchers: ids
                        },
                        type: 'GET',
                        success: (data) => {
                            if (data.success) {
                                location.reload();
                            } else {
                                toastr.error(data.message, data.code);
                            }
                        }
                    })
                }
            })
        } else {
            let ids = obtenerIdCheckDatatable(e.target.dataset.table);
            let message = '¿Desea marcar como <b>"PAGADO"</b> todas las Reservas de esta Facturación.?'
            if (ids.length > 0) {
                message = `¿Desea marcar como <b>"PAGADO"</b> las (${ids.length}) Reservas seleccionadas de esta Facturación.?`;
            }
            bootbox.confirm(message, (result) => {
                if (result) {
                    $.ajax({
                        url: `${location.origin}/admin/histories/agencies/billing/mark`,
                        data: {
                            agency_billing: e.target.dataset.last,
                            vouchers: ids
                        },
                        type: 'GET',
                        success: (data) => {
                            if (data.success) {
                                location.reload();
                            } else {
                                toastr.error(data.message, data.code);
                            }
                        }
                    })
                }
            })
        }


    }

    zoho_billing(e) {
        let ids = []
        if (e.target.dataset.voucher !== undefined && e.target.dataset.voucher === 'true') {
            ids = obtenerIdCheckDatatable();
            let message = `¿Desea facturar en ZOHO todas los vouchers de esta facturación.?`;
            if (ids.length > 0) {
                message = `¿Desea facturar en Zoho los (${ids.length}) vouchers seleccionados.?`;

            } else {
                toastr.info('Debe seleccionar al menos 1 reserva para enviar a zoho', 'Información')
            }

            bootbox.confirm(message, (result) => {
                if (result) {
                    location.href = `${location.origin}/admin/histories/agencies/billing/zoho/billing?agency_billing=${e.target.dataset.last}&vouchers=${ids}`
                }
            })
        } else {
            ids = obtenerIdCheckDatatable(e.target.dataset.table);
            let message = `¿Desea facturar en ZOHO todas los vouchers de esta facturación.?`;
            if (ids.length > 0) {
                message = `¿Desea facturar en Zoho los (${ids.length}) vouchers seleccionados.?`;
            }
            bootbox.confirm(message, (result) => {
                if (result) {
                    location.href = `${location.origin}/admin/histories/agencies/billing/zoho/billing?agency_billing=${e.target.dataset.last}&vouchers=${ids}`
                }
            })
        }


    }

    edit_field(e){
        bootbox.dialog({
            message: `<button class="close-modal-login" type="button" data-dismiss="modal"></button>
                      <label for="price-modal">Precio de la reserva</label>
                       <input id="price-modal" name="price" class="form-control" type="text" value="${e.target.dataset.price}">
`,
            buttons: {
                ok: {
                    label: "<span class='fa fa-check'></span> Actualizar",
                    className: 'btn-info',
                    callback: function () {
                        let price = document.getElementById('price-modal').value;

                        $.ajax({
                            url: `${location.origin}/admin/histories/agencies/billing/voucher/${e.target.dataset.id}/edit`,
                            data: {
                                billing: e.target.dataset.billing,
                                total_price: price
                            },
                            type: 'GET',
                            beforeSend: function () {
                                toastr.info('Enviando datos...')
                            },
                            success: function (data) {
                                location.href = data.redirect_to
                            }
                        })
                    }
                }
            }
        });
    }

    deny(e) {
        let url = e.currentTarget.dataset.href
        bootbox.dialog({
            title: 'Motivo de cancelación de solicitud de reserva',
            message: `<p class='text-danger small'>(*) Campos obligatorios</p>
                    <div class="row" data-controller="select2">
                        <div class="col-12 mb-2">
                            <label for="reason">
                                Motivo <span class="text-danger">*</span>
                            </label>
                            <select id="reason" class="c2ec_select required">
                                <option value=""></option>
                                <option value="No hay disponibilidad">No hay disponibilidad</option>
                                <option value="Reserva duplicada">Reserva duplicada</option>
                                <option value="No procede">No procede</option>
                                <option value="Otros">Otros</option>
                            </select>
                        </div>
                    </div>`,
            buttons: {
                cancel: {
                    label: "Cancelar",
                    className: 'btn-secondary'
                },
                ok: {
                    label: "Enviar",
                    className: 'btn-success',
                    callback: function (e) {
                        let count = 0;
                        let reason = $('#reason');

                        if (reason[0].selectedOptions.length === 0) {
                            reason[0].classList.add('is-invalid')
                            count = count + 1;
                        } else {
                            reason[0].classList.remove('is-invalid')
                        }

                        if (count > 0) {
                            return false;
                        } else {
                            $.ajax({
                                url: `${location.origin}${url}`,
                                data: {
                                    reason: reason[0].selectedOptions[0].value
                                },
                                type: 'GET'
                            })
                            $('button.bootbox-close-button').trigger('click');
                        }

                        return true;

                    }
                }
            }
        })
        setTimeout(() => {
            $('.bootbox.modal')[0].removeAttribute('tabindex');
        }, 500)
    }

    cancel_tickets(e) {
        let ids = obtenerIdCheckDatatable(e.target.dataset.id);
        if (ids.length < 1) {
            toastr.info('Debe seleccionar al menos un elemento para continuar con esta acción', 'Importante')
        } else {
            bootbox.confirm({
                message: `¿Seguro que desea eliminar estos ${ids.length} elementos? <br> <p style='font-size: .7em;' class='text-danger'>Tenga en cuenta que este proceso es inreversible.</p>`,
                buttons: {
                    confirm: {
                        label: '<i class="fa fa-check"></i> Aceptar',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: '<i class="fa fa-times"></i> Cancelar',
                        className: 'btn-secondary'
                    }
                },
                size: 'small',
                callback: function (result) {
                    if (result) {
                        $.ajax({
                            url: `${location.origin}/voucher/delete_tickets`,
                            data: {
                                format: 'json',
                                id: ids
                            },
                            type: 'GET',
                            success: function (data) {
                                if (data.success) {
                                    toastr.success(data.msg);
                                    setTimeout(() => {
                                        location.reload();
                                    }, 1000)
                                } else {
                                    toastr.error(data.msg);

                                }
                            }
                        })
                    }
                }
            })
        }


    }

}